import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv";
import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const LayersIcon = ({
  width = 21,
  height = 22,
  strokeColor = "var(--gray)",
}: IIconProps) => {
  return (
    <HyperDiv width={width} height={height} centeredY>
      <svg
        height="100%"
        width="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.698 10.658L24 12L11.998 19L0 12L2.301 10.658L11.998 16.316L21.698 10.658V10.658ZM11.998 21.315L2.301 15.657L0 17L11.998 24L24 17L21.698 15.658L11.998 21.315ZM11.998 2.315L20.03 7L11.998 11.685L3.969 7L11.998 2.315ZM11.998 0L0 7L11.998 14L24 7L11.998 0V0Z"
          fill={strokeColor}
        />
      </svg>
    </HyperDiv>
  );
};

export default LayersIcon;
